import Quill from "quill";

const BlockEmbed = Quill.import('blots/block/embed');

class Emotion extends BlockEmbed {
    static blotName: string;
    static tagName: string;
    static className: string;
    static create(value: any) {
        const node = super.create();
        if (value) {
            node.setAttribute('width', 100);
            node.setAttribute('height', 100);
            node.setAttribute('src', value);
        }
        return node;
    }

    static value(node: { getAttribute: (arg0: string) => any }) {
        const v = node.getAttribute('src');
        return v;
    }
}
Emotion.blotName = 'emotion';
Emotion.tagName = 'img';
Emotion.className = 'ql-emotion';

Quill.register(Emotion, true);
